import type { FC, PropsWithChildren, ReactNode } from 'react';
import { memo } from 'react';
import { styled } from 'styled-components';

import { StyledInputContainer } from './StyledInputContainer.ts';

export interface InputIconsRendererProps extends PropsWithChildren {
  iconStart?: ReactNode;
  iconEnd?: ReactNode;
}

const InputWithIconsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;

  ${StyledInputContainer} {
    flex: 1;
  }
`;

export const InputIconsRenderer: FC<InputIconsRendererProps> = memo(function InputIconsRenderer({ children, iconEnd, iconStart }) {
  if (iconStart || iconEnd) {
    return (
      <InputWithIconsContainer>
        {!!iconStart && iconStart}
        {children}
        {!!iconEnd && iconEnd}
      </InputWithIconsContainer>
    );
  }

  return children;
});
